import { http } from '@/services/http';
import type { CurrentUser } from '@/types/auth';

export type User = CurrentUser;

export const usersApi = {
  get(userId: number | string): Promise<User> {
    return http<User>({ url: `users/${userId}`, method: 'get' });
  },
  create(user: Partial<User>): Promise<User> {
    return http<User>({ url: 'users', method: 'post', data: user });
  },
  /**
   * Patches the user record. In legacy code this also picked up an
   * `<input id="image">` file from the DOM via FileReader; the Vue port
   * does that file → base64 step in the calling view component instead
   * (the service stays pure HTTP).
   */
  update(user: Partial<User> & { id: number }): Promise<User> {
    return http<User>({ url: `users/${user.id}`, method: 'patch', data: user });
  },
  search(pattern: string): Promise<User[]> {
    return http<User[]>({ url: 'users/search', method: 'get', params: { query: pattern } });
  },
};
